import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';

//- Containers
import ResourceContainer from '../../containers/Resource';

//- Material UI
import { withStyles } from '@material-ui/core/styles/index';
import CircularProgress from '@material-ui/core/CircularProgress';
import CheckIcon from '@material-ui/icons/CheckCircle';
import Button from "@material-ui/core/Button";

//- images
import { showErrors } from '../../modules/general';
import uploadToCloudIcon from "../../images/uploadToCloud.svg";
import documentIcon from "../../images/document.svg";

const styles = () => {
	return {
		dropzoneContainer : {
			position: "relative",
			//height : 100,
			width : '100%',
			textAlign: 'center',
			backgroundColor: '#f1f1f1',
			borderWidth: 5,
			borderColor: '#bbbbbb',
			borderStyle: 'dashed',
			borderRadius: 10,
			cursor : 'pointer',
			boxSizing: 'border-box',
			padding : 20,
		},
		fileUploadedContainer : {
			position: "relative",
			width : '100%',
			textAlign: 'center',
			backgroundColor: '#f1f1f1',
			borderWidth: 2,
			borderColor: '#bbbbbb',
			borderStyle: 'solid',
			borderRadius: 10,
			boxSizing: 'border-box',
			padding : 20,
			display : 'flex',
		},
		inputContainer : {
			marginTop : 20,
			marginBottom : 10,
		},
		inputInner : {
			position: "relative",
		},
		inputLabel : {
			marginBottom : 5,
		},
		check: {
			color: '#4CAF50',
			width: 40,
			height: 40,
			verticalAlign: 'middle',
			paddingRight: 5,
		},
		dragDrop : {
			fontFamily: 'Roboto-Bold',
			fontSize: 16,
			color: '#2F8ECB',
			letterSpacing: 0,
			textAlign: 'center',
		},
		uploadIcon: {
			marginRight : 12,
			display : 'inline-block',
			width : 53,
			height : 52,
			backgroundImage: `url('${uploadToCloudIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position : 'relative',
		},
		isUploading : {
			fontSize : 20,
			fontWeight : 900,
			letterSpacing : '-1px',
			position : 'absolute',
			width : '100%',
			height : '100%',
			backgroundColor : 'rgba(255, 255, 255, .9)',
			top: 0,
			left : 0,
			textAlign : 'center',
			border:'2px solid #2F8ECB',
			borderRadius : '4px',
			display : 'flex',
			alignItems : 'center',
			justifyItems : 'center',
			justifyContent : 'center',
		},
		isShowingSuccess : {
			border:'2px solid #4CAF50',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 110,
			height: 130,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			// cursor : 'pointer',
		},
	};
};

class FormFileUploader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isFetching : false,
			isReadyForUpload : true,
			isUploading : false,
			isShowingSuccess : false,
			files: [],
			resource : undefined,
		};
	}

	componentDidMount() {
		const { value, getResource } = this.props;

		// Check if it starts with a resource and show it
		if (value) {
			this.setState({ isFetching : true })
			getResource({
				params : {
					resourceIds : [value],
				},
				callback : (err, r) => {
					const resource = _.get(r, ['collections', 'resourceCollection', 0]);

					if (!resource) {
						showErrors('Problems showing existing file. Sorry.');
						return;
					}

					this.setState({
						isFetching : false,
						isReadyForUpload : false,
						resource,
					});
				}
			});
		}
	}

	onDrop = (files) => {
		this.setState({
			isUploading : true
		});
		//- Set state uploading
		const { addResource, onChange, path} = this.props;

		addResource({
			params : {},
			files : [{
				name : 'file',
				data : files[0],
			}],
			callback : (err, r) => {
				const resource = _.get(r, ['collections', 'resourceCollection', 0]);

				if (!resource) {
					showErrors('Problems uploading file. Sorry.');
					return;
				}
				const { resourceId } = resource;

				this.setState({
					isUploading : false,
					isShowingSuccess : true,
				});

				setTimeout(() => {
					this.setState({
						isShowingSuccess : false,
						isReadyForUpload : false,
						resource,
					});

					onChange(resourceId, path);

				}, 700);
			}
		});
	};

	render () {
		const { classes, label} = this.props;
		const {
			isReadyForUpload,
			isUploading,
			isShowingSuccess,
			resource,
			isFetching,
		} = this.state;

		return (<div className={classes.inputContainer}>
			<div className={classes.inputLabel}>
				{label}
			</div>

			<div className={classes.inputInner}>
				{isReadyForUpload && this.renderDropzone()}
				{resource && this.renderResource()}

				{isFetching &&
				<div className={classes.isUploading}>
					<CircularProgress />
					<span style={{marginLeft : 5}}>Fetching...</span>
				</div>
				}

				{isUploading &&
				<div className={classes.isUploading}>
					<CircularProgress />
					<span style={{marginLeft : 5}}>Uploading...</span>
				</div>
				}

				{isShowingSuccess &&
				<div className={`${classes.isUploading} ${classes.isShowingSuccess}`}>
					<span><CheckIcon className={classes.check}/></span> Upload successful
				</div>
				}
			</div>
		</div>);
	}

	renderDropzone = () => {
		const { classes } = this.props;
		return (
			<Dropzone onDrop={this.onDrop}>
				{({getRootProps, getInputProps, isDragActive}) => {
					return (
						<div
							{...getRootProps()}
							className={classNames(
								'dropzone',
								{'dropzone--isActive': isDragActive},
								classes.dropzoneContainer
							)}
						>
							<input {...getInputProps()} />
							<div className={classes.uploadIcon}/>
							<p className={classes.dragDrop}>
								Drag N’ Drop<br/>
								to upload your files
							</p>
							<Button variant="outlined" onClick={this.handleEdit} color="primary">
								or click to browse
							</Button>
						</div>
					);
				}}
			</Dropzone>
		)
	};

	handleClear = () => {
		this.setState({
			isFetching : false,
			isReadyForUpload : true,
			isUploading : false,
			isShowingSuccess : false,
			resource : undefined,
		});

		const { onChange, path} = this.props;
		onChange(undefined, path);
	}

	renderResource = () => {
		const { classes } = this.props;
		const { resource } = this.state;
		const { contentType, url } = resource;

		let preview = (
			<div>
				<div className={classes.documentIcon} />
			</div>
		);

		if (contentType) {
			if (contentType.match(/(png|jpg|jpeg|bmp)/)) {
				preview = (<img
					alt={`Uploaded file`}
					style={{maxHeight: 175, maxWidth: 175}}
					src={url}
				/>);
			} else if (contentType.match(/(pdf)/)) {
				preview = (
					<object
						data={url}
						style={{maxHeight: 175, maxWidth: 122}}
						type="application/pdf"
						width="122"
						height="175"
					>
						<a href={url}>attachment.pdf</a>
					</object>
				);
			}
		}

		return (
			<div className={classes.fileUploadedContainer}>
				<div>{preview}</div>
				<div style={{padding : 20}}>
					<div>
						<a href={url} target="_blank" rel='noreferrer noopener'>
							<div><strong>Download File</strong></div>
							<div>{contentType}</div>
						</a>
					</div>
					<div style={{marginTop : 20}}>
						<Button variant="outlined" onClick={this.handleClear}>Clear</Button>
					</div>
				</div>
			</div>
		);
	}

}

//- XXX only supports single file
FormFileUploader.propTypes = {
	label : PropTypes.string.isRequired,
	value :	PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange : PropTypes.func.isRequired,

	error : PropTypes.string,
	helpText : PropTypes.string,
	disabled : PropTypes.bool,
	required : PropTypes.bool,

	rows : PropTypes.number,
	gridProps : PropTypes.object,

	addResource : PropTypes.func.isRequired,
	getResource : PropTypes.func.isRequired,

/*
	name: PropTypes.string.isRequired,
	afterUpload : PropTypes.func,
	showErrors : PropTypes.func,
	resource : PropTypes.object,
	classes: PropTypes.object.isRequired,
	onlyOne : PropTypes.bool,
	stayOnSuccessAfterUpload : PropTypes.bool,
 */
};

export default _.flow([
	withStyles(styles),
	ResourceContainer,
])(FormFileUploader);
